"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VENTILATION_TYPES_NL = exports.HEATING_TYPES_NL = exports.FLOOR_TYPES_NL = exports.FloorType = exports.RoofingType = exports.RoofType = void 0;
var RoofType;
(function (RoofType) {
    RoofType["Slanted"] = "slanted";
    RoofType["Flat"] = "flat";
    RoofType["Mixed"] = "mixed";
    RoofType["Other"] = "other";
})(RoofType = exports.RoofType || (exports.RoofType = {}));
var RoofingType;
(function (RoofingType) {
    RoofingType["Tiles"] = "tiles";
    RoofingType["Bitumen"] = "bitumen";
    RoofingType["Epdm"] = "epdm";
    RoofingType["Slates"] = "slates";
    RoofingType["Thatch"] = "thatch";
    RoofingType["Other"] = "other";
})(RoofingType = exports.RoofingType || (exports.RoofingType = {}));
var FloorType;
(function (FloorType) {
    FloorType["Wood"] = "wood";
    FloorType["Flat"] = "flat";
    FloorType["Nehobo"] = "nehobo";
    FloorType["BeamAndBlock"] = "beamAndBlock";
    FloorType["Manta"] = "manta";
    FloorType["Kwaaitaal"] = "kwaaitaal";
    FloorType["Other"] = "other";
})(FloorType = exports.FloorType || (exports.FloorType = {}));
// could put in translations.ts but not very generally used
exports.FLOOR_TYPES_NL = {
    [FloorType.Wood]: 'hout',
    [FloorType.Flat]: 'vlak beton',
    [FloorType.Nehobo]: 'nehobo',
    [FloorType.BeamAndBlock]: 'balken broodjes',
    [FloorType.Manta]: 'manta',
    [FloorType.Kwaaitaal]: 'kwaaitaal',
    [FloorType.Other]: 'anders',
};
exports.HEATING_TYPES_NL = [
    // Index should correspond to the HouseService HeaterType
    'CR',
    'VR',
    'HR-100',
    'HR-104',
    'HR-107',
    'Lokale olie- of gasketel',
];
exports.VENTILATION_TYPES_NL = [
    // Index should correspond to the HouseService VentilationType
    'Mechanisch',
    'Natuurlijk',
    'Decentraal mechanisch',
    'Vraaggestuurd',
    'Gebalanceerd',
    'Geen',
];
